import React, { useState } from 'react';
import JSONViewer from '../JSONViewer';

export default function JsonSheet({ open, data, filename, onClose }) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const jsonText = JSON.stringify(data, null, 2);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(jsonText);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* ignore */
    }
  };

  const handleDownload = () => {
    const blob = new Blob([jsonText], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${(filename || 'documento').replace(/\.[^.]+$/, '')}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="dv-json-panel">
      <div className="dv-json-panel-head">
        <button type="button" className="dv-btn dv-json-back" onClick={onClose}>
          ← Volver a la ficha
        </button>
        <h2 className="dv-json-panel-title">Datos JSON</h2>
        <div className="dv-json-panel-actions">
          <button type="button" className="dv-btn" onClick={handleCopy}>
            {copied ? '✓ Copiado' : 'Copiar'}
          </button>
          <button type="button" className="dv-btn" onClick={handleDownload}>
            ↓ Descargar
          </button>
        </div>
      </div>
      <div className="dv-json-panel-body">
        <JSONViewer
          data={data}
          title=""
          height="100%"
          showCopyButton={false}
          showDownloadButton={false}
          className="dv-json-viewer-embed"
        />
      </div>
    </div>
  );
}
